import { usePushSubscription } from 'server';

/**
 * Event fires when IMS sends push notification that player's tag has changed or was removed.
 * Subscription for tag changes must be configured in CMS to receive this notifications.
 * @memberOf Playtech.API.events
 * @event player-tag-change
 * @type {callback}
 * @param {Object} details
 * @param {string} details.tag Name of the tag changed.
 * @param {string} details.value New value of the tag; not available for simple tags.
 * @param {boolean} details.removed If tag was removed from player.
 * @example Playtech.on('player-tag-change', ({ tag, value, removed }) => { ... });
 */
export const EVENT_PLAYER_TAG_CHANGE = 'player-tag-change';

export const useOnPlayerTagChange = (eventTarget) => {

    usePushSubscription(31133, () => (pushMessage) => {
        const { notificationPlayerTagChangeInfo } = pushMessage?.data?.notification || {};

        if (notificationPlayerTagChangeInfo) {
            const { tag, value, removed } = notificationPlayerTagChangeInfo;
            const event = new CustomEvent(EVENT_PLAYER_TAG_CHANGE, {
                detail: {
                    tag,
                    value,
                    removed
                }
            });

            eventTarget.dispatchEvent(event);
        }
    });
};
